"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinoutValidationResultMetadataSchema = exports.PinoutValidationResultEntrySchema = exports.PinoutValidationResultEntryStatusSchema = exports.PinoutValidationResultEntryStatus = exports.PinoutValidationInstanceMetadataSchema = exports.PinoutValidationResultKey = exports.PinoutRequirementTypeId = void 0;
const zod_1 = require("zod");
exports.PinoutRequirementTypeId = 'Pinout';
exports.PinoutValidationResultKey = 'PinoutValidationResult';
exports.PinoutValidationInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.PinoutValidationResultKey),
    referenceDesignator: zod_1.z.string(),
    packageName: zod_1.z.string(),
    packageStorePackageId: zod_1.z.string(),
});
var PinoutValidationResultEntryStatus;
(function (PinoutValidationResultEntryStatus) {
    PinoutValidationResultEntryStatus["PASS"] = "PASS";
    PinoutValidationResultEntryStatus["FAIL"] = "FAIL";
    PinoutValidationResultEntryStatus["UNMAPPED"] = "UNMAPPED";
    PinoutValidationResultEntryStatus["TWO_PIN"] = "2PIN";
    PinoutValidationResultEntryStatus["ERROR"] = "ERROR";
    PinoutValidationResultEntryStatus["NOT_UNDERSTOOD"] = "NOT_UNDERSTOOD";
})(PinoutValidationResultEntryStatus || (exports.PinoutValidationResultEntryStatus = PinoutValidationResultEntryStatus = {}));
exports.PinoutValidationResultEntryStatusSchema = zod_1.z.nativeEnum(PinoutValidationResultEntryStatus);
exports.PinoutValidationResultEntrySchema = zod_1.z.object({
    designSignal: zod_1.z.string().optional(),
    designPin: zod_1.z.string().optional(),
    packageStoreSignal: zod_1.z.string().optional(),
    packageStorePin: zod_1.z.string().optional(),
    status: exports.PinoutValidationResultEntryStatusSchema,
});
exports.PinoutValidationResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.PinoutValidationResultKey),
    results: zod_1.z.array(exports.PinoutValidationResultEntrySchema),
});
//# sourceMappingURL=PinoutValidationInstanceMetadata.js.map